import { useEffect, useRef, useState } from 'react';
import { NativeScrollEvent, Dimensions } from 'react-native';

export const useScrollCloseToBottom = (paddingToBottom = Dimensions.get('window').height / 2) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [isBlockingValidation, setIsBlockingValidation] = useState(false);
  const [isCloseToBottom, setIsCloseToBottom] = useState(false);

  const validateIsCloseToBottom = ({
    layoutMeasurement,
    contentOffset,
    contentSize,
  }: NativeScrollEvent) => {
    if (isBlockingValidation) {
      return;
    }
    const currentPos = layoutMeasurement.height + contentOffset.y;
    const offsetHeight = contentSize.height - paddingToBottom;

    const isClose = currentPos >= offsetHeight;

    setIsCloseToBottom(isClose);
  };

  const resetIsCloseToBottom = () => {
    setIsCloseToBottom(false);
  };

  const preventValidationByAddingDelay = (delay = 500) => {
    setIsBlockingValidation(true);
    resetIsCloseToBottom();
    timeoutRef.current = setTimeout(() => {
      setIsBlockingValidation(false);
    }, delay);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    isCloseToBottom,
    validateIsCloseToBottom,
    resetIsCloseToBottom,
    preventValidationByAddingDelay,
  };
};
